import { useParams } from "react-router-dom";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../primaryComponents";
import secondaryComponents from "../..";
import { useMemo, useState } from "react";
import { cleanObject, deepCopyFunction } from "../../../../helpers";
import { useCart } from "../../../../hooks/useCart";
import { useGetProductBatchesCustomised } from "../../../../hooks/api/queries";

export const ProductBatchSelection = ({
  productId,
  variantId = null,
  closeModal = () => {},
}) => {
  const { store_id } = useParams();
  const [params, setParams] = useState(
    cleanObject({
      store_id: store_id,
      product_id: productId,
      variant_id: variantId,
      is_custom_batch: true,
      query: "",
      per_page: 10,
    }),
  );
  const { addProductBatchId, cartItems } = useCart({});

  const { data: productBatches, isLoading: isFetchingBatches } =
    useGetProductBatchesCustomised({
      queries: "",
      querParams: params,
    });
  const isLoading = isFetchingBatches;

  const cartIndex = useMemo(() => {
    const newCartItems = deepCopyFunction(cartItems);
    const itemId = `${productId || ""}${variantId || ""}`;

    const cartIndex = newCartItems.findIndex(
      (item) => `${item?.id}` === `${itemId}`,
    );
    return cartIndex;
  }, [cartItems]);

  return (
    <div>
      <div className={globalStyles.cardWithBorder}>
        <h4 className="mb-3">Select Product Batch</h4>
        <primaryComponents.SearchField
          placeholder="Search product batch"
          trigger={(value) => setParams((prev) => ({ ...prev, query: value }))}
          value={params?.query || ""}
          triggerOnInput={true}
          showsearchBtn={true}
          classNames="mb-1"
        />

        <secondaryComponents.LoaderHelper
          isLoading={isLoading}
          classNames={"mt-5"}
        >
          <div className="d-flex flex-column" style={{ gap: "10px" }}>
            {productBatches?.map((productBatch) => {
              const isInCart =
                cartItems?.[cartIndex]?.batch_id === productBatch?.batch_id
                  ? true
                  : false;
              return (
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{ gap: "10px" }}
                  key={productBatch?.batch_id}
                >
                  <p className="dark--text">{productBatch?.batch_name}</p>

                  <primaryComponents.Button
                    classNames={`btn ${isInCart ? "btn--outline" : "btn--primary"} smallBtn`}
                    style={{ width: "125px", height: "40px" }}
                    onClick={() => {
                      addProductBatchId({
                        batch_id: isInCart ? null : productBatch?.batch_id,
                        batch_name: isInCart ? null : productBatch?.batch_name,
                        cartIndex,
                      });
                    }}
                  >
                    {isInCart ? "Remove" : "Select batch"}
                  </primaryComponents.Button>
                </div>
              );
            })}
          </div>
        </secondaryComponents.LoaderHelper>
      </div>
      <primaryComponents.Button
        classNames={"btn btn--primary mt-3 cover"}
        onClick={closeModal}
      >
        Continue
      </primaryComponents.Button>
    </div>
  );
};
